import { gql } from '@apollo/client';

export interface SendMessageMutationVariables {
  courseId: string;
  input: {
    message: {
      title: string;
      content: string;
    };
    students: string[];
  };
}

export const sendMessageMutation = gql`
  mutation SendMessageMutation($courseId: String!, $input: SendMessageMutationInput!) {
    message(courseId: $courseId, input: $input) @rest(type: "Message", path: "courses/{args.courseId}/students/messages", method: "POST") {
      NoResponse
    }
  }
`;
